<template>
  <cmp-site-container>
    <!-- 
        - Display a page header
        -->
    <mp-page-header
      title="Clips"
      subtitle="Manager Clips and view their streams"
    />
    <!-- 
        - display an object list
         -->
    <cmp-content-block title="Clips">
      <clips-clip-list />
    </cmp-content-block>
  </cmp-site-container>
</template>

<script>
import CmpSiteContainer from "@/components/Structural/SiteContainer";
import CmpContentBlock from "@/components/Structural/ContentBlock";

export default {
  name: "RecordingsController",
  components: { CmpContentBlock, CmpSiteContainer }
};
</script>

<style scoped></style>
